export const contentLabels = [
  "Total number of tenure-track or tenured faculty",
  "Number of women in tenure-track or tenured faculty positions",
  "[Calculated] Percentage of women in tenure-track or tenured faculty positions",
  "Total number of graduate students",
  "Number of women graduate students",
  "[Calculated] Percentage of women graduate students",
  "Total number of post doctoral associates",
  "Number of women post doctoral associates",
  "[Calculated] Percentage of women post doctoral associates",
  "Is there a family leave policy for graduate students? If so, describe.",
  "Is there family health insurance for graduate students? If so, is it included in the stipend?",
  "Do you have a Woman in Physics Group? If yes, please include link to their website if they have one.",
  "Do you have a Physics Graduate Student Association? If yes, please include link to their website if they have one.",
  "What other relevant student groups are there in your institution?",
  "Has your institution ever hosted a Conference for Undergraduate Women in Physics? If yes, which year?",
  "Has your institution ever hosted an APS Climate Site Visit for Women and Minorities in Physics?",
  "Please describe why someone applying to graduate school who is interested in an inclusion department should choose your department.",
  "Please include the name of faculty or staff member and an email they can be reached at for further questions."
];
export const surveyPrompts = contentLabels.filter((str) => !/calculated/i.test(str));
